import { RiskEngineStatusEnum } from '../../../../shared/models';
import { DEFAULT_RISK_ENGINE_CODE } from './default-risk-engine-code';

export interface DefaultRiskEngineConfig {
  name: string;
  description: string;
  status: RiskEngineStatusEnum;
  initialVersion: {
    name: string;
    version: number;
    code: string;
  };
}

export const DEFAULT_RISK_ENGINE: DefaultRiskEngineConfig = {
  name: 'Default Risk Engine',
  description: 'Default risk engine created with workspace',
  status: RiskEngineStatusEnum.online,
  initialVersion: {
    name: 'Initial Version',
    version: 1,
    code: DEFAULT_RISK_ENGINE_CODE,
  },
};
